import { graphql } from "gql.tada";
import { RichTextFragment } from "@queries/fragments/RichTextFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

export const GetFaqPageById = graphql(
  `
    query GetFaqPageById($id: String!, $locale: String, $preview: Boolean) {
      faqPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        internalName
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        faq {
          sys {
            id
          }
          faqTitle
          faqFilterTitle
          faqItemsCollectionCollection(limit: 50) {
            items {
              sys {
                id
              }
              title
              filterTagText
              description {
                ...RichTextFragment
              }
            }
          }
        }
      }
    }
  `,
  [RichTextFragment, ThemeFragment, MetadataFragment]
);
